import React, { useState } from 'react';
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from '@mui/material';

import { useRouter } from 'src/hooks/useRouter';
import { routesMap } from 'src/routes';
import { apiService } from 'src/services/apiService';
import { UserCreate } from '../UserCreate';
import { useDebounce } from 'src/hooks/useDebounce';

import { useGetUsers, UserQueryTypes, UsersList } from 'src/entities/user';

interface Props {}
export const UsersPage: React.FunctionComponent<Props> = ({}) => {
  const [searchQuery, setSearchQuery] = useState('');

  const debouncedSearchQuery = useDebounce(searchQuery, 500);

  const { push, query } = useRouter();

  const requestQuery = {
    limit: query.limit || 50,
    offset: query.offset || 0,
    query: debouncedSearchQuery as string,
    type: query.type as string,
    telegramSubscribed: query.telegramSubscribed?.[0],
    hasVendorId: query.hasVendorId?.[0],
  };

  const usersRequest = useGetUsers({
    variables: requestQuery,
    skip: !!requestQuery.query && !!requestQuery.telegramSubscribed && !!requestQuery.hasVendorId
  });

  const handleOnChange = (params: {
    page?: number;
    limit: number;
    telegramSubscribed?: boolean | null;
    hasVendorId?: boolean | null;
    type?: string | null;
  }) => {
    let nextRequestQuery = {
      ...requestQuery,
      telegramSubscribed: params.telegramSubscribed,
      hasVendorId: params.hasVendorId,
      type: params.type,
    };

    if (params.page && params.limit) {
      nextRequestQuery = {
        ...nextRequestQuery,
        offset: params.page * params.limit,
        limit: params.limit,
      };
    }

    push(routesMap.users.getRoute(), nextRequestQuery);
  };

  return (
    <div>
      <Paper>
        <Box p={2} pb={0} display="flex" alignItems="center">
          <Box>
            <TextField
              label="Поиск"
              variant="outlined"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
          </Box>
          <Box ml={2}>
            <FormControl>
              <InputLabel id="type">Должность</InputLabel>
              <Select
                labelId="type"
                value={requestQuery.type || ''}
                label="Должность"
                onChange={e =>
                  handleOnChange({
                    ...requestQuery,
                    type: e.target.value,
                  })
                }
                sx={{ minWidth: '200px' }}
              >
                <MenuItem key="" value="">
                  Все
                </MenuItem>
                {Object.entries(UserQueryTypes).map(([key, type]) => (
                  <MenuItem key={key} value={key}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <Box ml={2}>
            <FormControlLabel
              label="Telegram"
              checked={Boolean(requestQuery?.telegramSubscribed)}
              onChange={() =>
                handleOnChange({
                  ...requestQuery,
                  telegramSubscribed: requestQuery.telegramSubscribed
                    ? null
                    : true,
                })
              }
              control={<Checkbox />}
            />
          </Box>
                    <Box ml={2}>
            <FormControlLabel
              label="Код торгового агента"
              checked={Boolean(requestQuery?.hasVendorId)}
              onChange={() =>
                handleOnChange({
                  ...requestQuery,
                  hasVendorId: requestQuery.hasVendorId
                    ? null
                    : true,
                })
              }
              control={<Checkbox />}
            />
          </Box>
        </Box>
      </Paper>
      <UsersList
        actions={[() => <UserCreate onCreate={usersRequest.mutate} />]}
        data={usersRequest.data?.data}
        totalCount={usersRequest.data?.totalCount}
        onFetch={usersRequest.mutate}
        onChange={handleOnChange}
        loading={usersRequest.isLoading}
        limit={parseInt(requestQuery.limit, 10)}
        offset={parseInt(requestQuery.offset, 10)}
      />
    </div>
  );
};
